import { render, staticRenderFns } from "./registration-periods-list.vue?vue&type=template&id=35e1deac"
import script from "./registration-periods-list.vue?vue&type=script&lang=js"
export * from "./registration-periods-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports